import { render, staticRenderFns } from "./Interviewer.vue?vue&type=template&id=50c6a4d5"
import script from "./Interviewer.vue?vue&type=script&lang=js"
export * from "./Interviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports